module.exports = __webpack_public_path__ + "static/img/Pfiffner2.326be322.jpg";